<script setup lang="ts">
const props = defineProps<{
  topArticles: StoryBlokArticle[]
  mostReadArticles: StoryBlokArticle[]
  banner?: {
    image: StoryBlokImage
    link: StoryBlokLink
  }
  nepodcento?: {
    button: StoryBlokButton[]
    image: StoryBlokImage
    title: string
    text: StoryBlokRichText
  }
}>()

const appConfig = useAppConfig()
const blog = appConfig.blog

const tabIdx = ref(0)
</script>

<template>
  <div class="grid lg:grid-cols-[auto,360px] gap-5">
    <div>
      <slot />
    </div>
    <div>
      <BaseTabs
        v-model="tabIdx" class="font-semibold gap-2.5 text-24px border-primary border-opacity-40"
        :items="[blog.mostReadArticles, blog.topArticles]"
      />
      <div>
        <div v-if="tabIdx === 0">
          <BlogRightPanelList :items="props.mostReadArticles" />
        </div>
        <div v-if="tabIdx === 1">
          <BlogRightPanelList :items="props.topArticles" />
        </div>
      </div>

      <div v-if="props.banner?.link" class="mt-10">
        <StoryblokLink v-bind="props.banner.link">
          <StoryblokImage :src="props.banner.image" width="300" height="600" class="rounded-xl" />
        </StoryblokLink>
      </div>

      <div v-if="props.nepodcento" class="mt-10">
        <h3>Poslechněte si</h3>
        <div class="bg-podcast text-white rounded-xl flex mt-2.5 max-w-360px">
          <div class="py-5 pl-5 max-w-215px">
            <div class="text-xl font-semibold pb-2.5">
              {{ props.nepodcento.title }}
            </div>
            <StoryblokRichText :document="props.nepodcento.text" class="text-sm" />
            <StoryblokButton v-bind="props.nepodcento.button[0]" class="mt-2.5" />
          </div>
          <div class="relative flex items-end">
            <StoryblokImage :src="props.nepodcento.image" width="134" height="200" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
